import {
  AddUserGroupRequest,
  GetUserGroupsRequest,
  GetUsersRequest,
  User,
  UserGroup,
} from '@ulysses-inc/harami_api_client'
import Redux from 'redux'
import actions, {
  changeIsShowEditUserDrawer as changeIsShowEditUserDrawerAction,
  changeUpdatedUsersFlag as changeUpdatedUsersFlagAction,
  getUser as getUserAction,
  getUserGroups as getUserGroupsAction,
  getUsers as getUsersAction,
  updateUser as updateUserAction,
} from './actions'
import { GetUsersFilter } from './types'

const getUsers = (
  dispatch: Redux.Dispatch,
  request: GetUsersRequest,
  filter?: GetUsersFilter,
) => {
  dispatch(getUsersAction(request, filter))
}

const changeUsersPage = (
  dispatch: Redux.Dispatch,
  page: number,
  pageSize?: number,
  filter?: GetUsersFilter,
) => {
  dispatch(actions.changeUsersPage(page, pageSize, filter))
}

const changeUsersSize = (
  dispatch: Redux.Dispatch,
  pageSize: number,
  filter?: GetUsersFilter,
) => {
  dispatch(actions.changeUsersSize(pageSize, filter))
}

const updatePagination = (
  dispatch: Redux.Dispatch,
  limit: number,
  offset: number,
) => {
  dispatch(actions.updatePagination(limit, offset))
}

const updateUser = (
  dispatch: Redux.Dispatch,
  userId: string,
  user: User,
  currentPassword?: string,
) => {
  dispatch(updateUserAction(userId, user, currentPassword))
}

const changeIsShowEditUserDrawer = (
  dispatch: Redux.Dispatch,
  isShowEditUserDrawer: boolean,
) => {
  dispatch(changeIsShowEditUserDrawerAction(isShowEditUserDrawer))
}

const changeUpdatedUsersFlag = (
  dispatch: Redux.Dispatch,
  updatedUsers: boolean,
) => {
  dispatch(changeUpdatedUsersFlagAction(updatedUsers))
}

const updateActiveUserId = (dispatch: Redux.Dispatch, activeUserId: string) => {
  dispatch(actions.updateActiveUserId(activeUserId))
}

const updateSegmentIndex = (dispatch: Redux.Dispatch, segmentIndex: number) => {
  dispatch(actions.updateSegmentIndex(segmentIndex))
}

const getUserGroups = (
  dispatch: Redux.Dispatch,
  request: GetUserGroupsRequest,
) => {
  dispatch(getUserGroupsAction(request))
}

const changeUserGroupsPage = (
  dispatch: Redux.Dispatch,
  page: number,
  pageSize?: number,
) => {
  dispatch(actions.changeUserGroupsPage(page, pageSize))
}

const changeUserGroupsSize = (dispatch: Redux.Dispatch, pageSize: number) => {
  dispatch(actions.changeUserGroupsSize(pageSize))
}

const addUserGroup = (
  dispatch: Redux.Dispatch,
  request: AddUserGroupRequest,
) => {
  dispatch(actions.addUserGroup(request))
}

const updateUserGroup = (
  dispatch: Redux.Dispatch,
  userGroupId: number,
  userGroup: UserGroup,
) => {
  dispatch(actions.updateUserGroup(userGroupId, userGroup))
}

const deleteUserGroup = (dispatch: Redux.Dispatch, userGroupId: number) => {
  dispatch(actions.deleteUserGroup(userGroupId))
}

const validateDeleteUserGroup = (
  dispatch: Redux.Dispatch,
  userGroupId: number,
) => {
  dispatch(actions.validateDeleteUserGroup(userGroupId))
}

const resetValidateDeleteUserGroup = (dispatch: Redux.Dispatch) => {
  dispatch(actions.resetValidateDeleteUserGroup())
}

const changeIsShowEditUserGroupDrawer = (
  dispatch: Redux.Dispatch,
  isShowEditUserGroupDrawer: boolean,
) => {
  dispatch(actions.changeIsShowEditUserGroupDrawer(isShowEditUserGroupDrawer))
}

const updateActiveUserGroupId = (
  dispatch: Redux.Dispatch,
  activeUserGroupId?: number,
) => {
  dispatch(actions.updateActiveUserGroupId(activeUserGroupId))
}

const getUser = (dispatch: Redux.Dispatch, userId: string) => {
  dispatch(getUserAction(userId))
}

export default {
  getUsers,
  changeUsersPage,
  changeUsersSize,
  updatePagination,
  updateUser,
  changeIsShowEditUserDrawer,
  changeUpdatedUsersFlag,
  updateActiveUserId,
  updateSegmentIndex,
  getUserGroups,
  changeUserGroupsPage,
  changeUserGroupsSize,
  addUserGroup,
  updateUserGroup,
  deleteUserGroup,
  resetValidateDeleteUserGroup,
  validateDeleteUserGroup,
  changeIsShowEditUserGroupDrawer,
  updateActiveUserGroupId,
  getUser,
}
